const triplePlayProvvalueerOptions = [
  {
    label: 'Waar ben je nu klant?',
    value: '',
    attrs: {
      disabled: true,
      selected: true,
    },
  },
  {
    value: '66',
    label: 'Budget',
  },
  {
    value: '64',
    label: 'Caiway',
  },
  {
    value: '67',
    label: 'DELTA',
  },
  {
    value: '72',
    label: 'Freedom',
  },
  {
    value: '21',
    label: 'KPN',
  },
  {
    value: '56',
    label: 'Online',
  },
  {
    value: '63',
    label: 'Odido',
  },
  {
    value: '65',
    label: 'Youfone',
  },
  {
    value: '33',
    label: 'Ziggo',
  },
  {
    value: 0,
    label: 'Onbekend',
  },
];

export default triplePlayProvvalueerOptions;
